import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SubscriberComponent } from './subscriber.component';
import {AuthGuard} from '../admin/auth/auth.guard';

const routes: Routes = [
  {
    path: 'subscriber',
    children: [
      {
        path: '',
        redirectTo: '/tabs/home',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
  },
  {
    path: 'aboutus',
    loadChildren: () => import('./aboutus/aboutus.module').then( m => m.AboutusPageModule)
  },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then( m => m.AccountPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'addfeedback',
    loadChildren: () => import('./addfeedback/addfeedback.module').then( m => m.AddfeedbackPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'appointment',
    loadChildren: () => import('./appointment/appointment.module').then( m => m.AppointmentPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'appointmentbook',
    loadChildren: () => import('./appointmentbook/appointmentbook.module').then( m => m.AppointmentbookPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'appointmentdetail',
    loadChildren: () => import('./appointmentdetail/appointmentdetail.module').then( m => m.AppointmentdetailPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'appts',
    loadChildren: () => import('./appts/appts.module').then( m => m.ApptsPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'blogs',
    loadChildren: () => import('./blogs/blogs.module').then( m => m.BlogsPageModule)
  },
  {
    path: 'chats',
    loadChildren: () => import('./chats/chats.module').then( m => m.ChatsPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'chatscreen',
    loadChildren: () => import('./chatscreen/chatscreen.module').then( m => m.ChatscreenPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'doctroslist',
    loadChildren: () => import('./doctroslist/doctroslist.module').then( m => m.DoctroslistPageModule)
  },
  {
    path: 'chatwithdoctor',
    loadChildren: () => import('./chatwithdoctor/chatwithdoctor.module').then( m => m.ChatwithdoctorPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'doctorprofile',
    loadChildren: () => import('./doctorprofile/doctorprofile.module').then( m => m.DoctorprofilePageModule)
  },
  {
    path: 'feedback',
    loadChildren: () => import('./feedback/feedback.module').then( m => m.FeedbackPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'filter',
    loadChildren: () => import('./filter/filter.module').then( m => m.FilterPageModule)
  },
  {
    path: 'finddoctor',
    loadChildren: () => import('./finddoctor/finddoctor.module').then( m => m.FinddoctorPageModule)
  },
  {
    path: 'forgotpassword',
    loadChildren: () => import('./forgotpassword/forgotpassword.module').then( m => m.ForgotpasswordPageModule)
  },
  {
    path: 'help',
    loadChildren: () => import('./help/help.module').then( m => m.HelpPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'lab',
    loadChildren: () => import('./lab/lab.module').then( m => m.LabPageModule)
  },
  {
    path: 'labdetails',
    loadChildren: () => import('./labdetails/labdetails.module').then( m => m.LabdetailsPageModule)
  },
  {
    path: 'location',
    loadChildren: () => import('./location/location.module').then( m => m.LocationPageModule)
  },
  {
    path: 'map',
    loadChildren: () => import('./map/map.module').then( m => m.MapPageModule)
  },
  {
    path: 'medical',
    loadChildren: () => import('./medical/medical.module').then( m => m.MedicalPageModule)
  },
  {
    path: 'medicaldetail',
    loadChildren: () => import('./medicaldetail/medicaldetail.module').then( m => m.MedicaldetailPageModule)
  },
  {
    path: 'medicalmap',
    loadChildren: () => import('./medicalmap/medicalmap.module').then( m => m.MedicalmapPageModule)
  },
  {
    path: 'myfeedbacks',
    loadChildren: () => import('./myfeedbacks/myfeedbacks.module').then( m => m.MyfeedbacksPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then( m => m.ProfilePageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'edit-profile-image',
    loadChildren: () => import('./edit-profile-image/edit-profile-image.module').then( m => m.EditProfileImageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'readblog',
    loadChildren: () => import('./readblog/readblog.module').then( m => m.ReadblogPageModule)
  },
  {
    path: 'settings',
    loadChildren: () => import('./settings/settings.module').then( m => m.SettingsPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'signin',
    loadChildren: () => import('./signin/signin.module').then( m => m.SigninPageModule)
  },
  {
    path: 'signin-doctor',
    loadChildren: () => import('./signin-doctor/signin-doctor.module').then( m => m.SigninDoctorPageModule)
  },
  {
    path: 'specilities',
    loadChildren: () => import('./specilities/specilities.module').then( m => m.SpecilitiesPageModule)
  },
  {
    path: 'terms',
    loadChildren: () => import('./terms/terms.module').then( m => m.TermsPageModule)
  },
  {
    path: 'tests',
    loadChildren: () => import('./tests/tests.module').then( m => m.TestsPageModule)
  },
  {
    path: 'select-language',
    loadChildren: () => import('./select-language/select-language.module').then( m => m.SelectLanguagePageModule)
  },
  {
    path: 'article',
    loadChildren: () => import('./article/article.module').then( m => m.ArticleModule)
  },
  {
    path: 'article-list',
    loadChildren: () => import('./article/article-list/article-list.module').then( m => m.ArticleListModule)
  },
  {
    path: 'article-detail',
    loadChildren: () => import('./article/article-detail/article-detail.module').then( m => m.ArticleDetailModule)
  },
  {
    path: 'article-comments',
    loadChildren: () => import('./article/article-comments/article-comments.module').then( m => m.ArticleCommentsModule)
  },
  {
    path: 'announcements',
    loadChildren: () => import('./announcements/announcements.module').then( m => m.AnnouncementsModule)
  },
  {
    path: 'announcement-detail',
    loadChildren: () => import('./announcements/announcement-detail/announcement-detail.module').then( m => m.AnnouncementDetailModule)
  },
  {
    path: 'conference-calendar',
    loadChildren: () => import('./conference-calendar/conference-calendar.module').then( m => m.ConferenceCalendarModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'emergency',
    loadChildren: () => import('./emergency/emergency.module').then( m => m.EmergencyModule)
  },
  {
    path: 'emergency-request-center',
    loadChildren: () => import('./emergency-request-center/emergency-request-center.module').then( m => m.EmergencyRequestCenterModule)
  },
  {
    path: 'openable-modal-toolbar-empty',
    loadChildren: () =>
    import('./openable-modal-toolbar-empty/openable-modal-toolbar-empty.module').then( m => m.OpenableModalToolbarEmptyModule)
  },
  {
    path: 'tabs/instant-appointments',
    loadChildren: () => import('./instant-appointment/instant-appointment.module').then( m => m.InstantAppointmentModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'choose-doctor',
    loadChildren: () => import('./choose-doctor/choose-doctor.module').then( m => m.ChooseDoctorModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'choose-doctor-list-modal',
    loadChildren: () => import('./choose-doctor-list-modal/choose-doctor-list-modal.module').then( m => m.ChooseDoctorListModalModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'doctor-profile-detail-modal',
    loadChildren: () =>
    import('./doctor-profile-detail-modal/doctor-profile-detail-modal.module').then( m => m.DoctorProfileDetailModalModule)
  },
  {
    path: 'video-call',
    loadChildren: () => import('./video-call/video-call.module').then( m => m.VideoCallModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'call-feedback',
    loadChildren: () => import('./call-feedback/call-feedback.module').then( m => m.CallFeedbackModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'notification-badge',
    loadChildren: () => import('./notification-badge/notification-badge.module').then( m => m.NotificationBadgeModule)
  },
  {
    path: 'notification-panel',
    loadChildren: () => import('./notification-panel/notification-panel.module').then( m => m.NotificationPanelModule)
  },
  {
    path: 'notification-detail',
    loadChildren: () => import('./notification-detail/notification-detail.module').then( m => m.NotificationDetailModule)
  },
  {
    path: 'pharmacy',
    loadChildren: () => import('./pharmacy/pharmacy.module').then( m => m.PharmacyModule)
  },
  {
    path: 'pharmacy-detail',
    loadChildren: () => import('./pharmacy-detail/pharmacy-detail.module').then( m => m.PharmacyDetailModule)
  },
  {
    path: 'pharmacy-map',
    loadChildren: () => import('./pharmacy-map/pharmacy-map.module').then( m => m.PharmacyMapModule)
  },
  {
    path: 'family-health-center',
    loadChildren: () => import('./family-health-center/family-health-center.module').then( m => m.FamilyHealthCenterModule)
  },
  {
    path: 'family-health-center-detail',
    loadChildren: () =>
    import('./family-health-center-detail/family-health-center-detail.module').then( m => m.FamilyHealthCenterDetailModule),
  },
  {
    path: 'ask-question-form-profile',
    loadChildren: () => import('./ask-question-form-profile/ask-question-form-profile.module').then( m => m.AskQuestionFormProfileModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'question-detail',
    loadChildren: () => import('./question-detail/question-detail.module').then( m => m.QuestionDetailModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'question-pool',
    loadChildren: () => import('./question-pool/question-pool.module').then( m => m.QuestionPoolModule)
  },
  {
    path: 'ask-question-form-pool',
    loadChildren: () => import('./ask-question-form-pool/ask-question-form-pool.module').then( m => m.AskQuestionFormPoolModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then( m => m.AuthPageModule)
  },
  {
    path: 'try',
    loadChildren: () => import('./try-to-edit-store/try-to-edit-store.module').then( m => m.TryToEditStoreModule)
  },
  {
    path: 'signin-doctor',
    loadChildren: () => import('./signin-doctor/signin-doctor.module').then( m => m.SigninDoctorPageModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('../admin/admin-routing.module').then( m => m.AdminRoutingModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_ADMIN'
    }
  },
  {
    path: '',
    redirectTo: '/tabs/home',
    pathMatch: 'full'
  },
  {
    path: 'take-appointment',
    loadChildren: () => import('./take-appointment/take-appointment.module').then( m => m.TakeAppointmentPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'expert-appointment-view',
    loadChildren: () =>
    import('./expert-appointments-for-subscriber/expert-appointments-for-subscriber.module')
    .then( m => m.ExpertAppointmentsForSubscriberPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'expert-appointment-days-view',
    loadChildren: () =>
    import('./expert-appointments-per-days-for-subscriber/expert-appointments-per-days-for-subscriber.module')
    .then( m => m.ExpertAppointmentsPerDaysForSubscriberPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'branch-detail',
    loadChildren: () => import('./branch-detail/branch-detail.module').then( m => m.BranchDetailPageModule)
  },
  {
    path: 'clinic-detail',
    loadChildren: () => import('./clinic-detail/clinic-detail.module').then( m => m.ClinicDetailPageModule)
  },
  {
    path: 'expert-search-in-detail',
    loadChildren: () => import('./expert-search-in-detail/expert-search-in-detail.module').then( m => m.ExpertSearchInDetailPageModule)
  },
  {
    path: 'expert-filters-modal',
    loadChildren: () => import('./expert-filters-modal/expert-filters-modal.module').then( m => m.ExpertFiltersModalPageModule)
  },
  {
    path: 'settings-article-likes',
    loadChildren: () => import('./settings-article-likes/settings-article-likes.module').then( m => m.SettingsArticleLikesPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'settings-article-comments',
    loadChildren: () =>
    import('./settings-article-comments/settings-article-comments.module').then( m => m.SettingsArticleCommentsPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'settings-article-comments-detail',
    loadChildren: () =>
    import('./settings-article-comments-detail/settings-article-comments-detail.module')
    .then( m => m.SettingsArticleCommentsDetailPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'settings-questions',
    loadChildren: () => import('./settings-questions/settings-questions.module').then( m => m.SettingsQuestionsPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'settings-questions-detail',
    loadChildren: () =>
    import('./settings-questions-detail/settings-questions-detail.module')
    .then( m => m.SettingsQuestionsDetailPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'settings-rates',
    loadChildren: () => import('./settings-rates/settings-rates.module').then( m => m.SettingsRatesPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'first-aids',
    loadChildren: () => import('./first-aids/first-aids.module').then( m => m.FirstAidsPageModule)
  },
  {
    path: 'first-aid-detail',
    loadChildren: () => import('./first-aid-detail/first-aid-detail.module').then( m => m.FirstAidDetailPageModule)
  },
  {
    path: 'filtered-qestions',
    loadChildren: () => import('./filtered-qestions/filtered-qestions.module').then( m => m.FilteredQestionsPageModule)
  },
  {
    path: 'doctor-profile-type-modal',
    loadChildren: () =>
    import('./doctor-profile-type-modal/doctor-profile-type-modal.module').then( m => m.DoctorProfileTypeModalPageModule)
  },
  {
    path: 'video-chat',
    loadChildren: () => import('./video-chat/video-chat.module').then( m => m.VideoChatPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'pending-account',
    loadChildren: () => import('./pending-account/pending-account.module').then( m => m.PendingAccountPageModule)
  },
  {
    path: 'clinic-location',
    loadChildren: () => import('./clinic-location/clinic-location.module').then( m => m.ClinicLocationPageModule)
  },
  {
    path: 'appt-direction-modal',
    loadChildren: () => import('./appt-direction-modal/appt-direction-modal.module').then( m => m.ApptDirectionModalPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
  {
    path: 'checkout-iyzico',
    loadChildren: () => import('./checkout-iyzico/checkout-iyzico.module').then( m => m.CheckoutIyzicoPageModule)
  },
  {
    path: 'about-modal',
    loadChildren: () => import('./about-modal/about-modal.module').then( m => m.AboutModalPageModule)
  },
  {
    path: 'privacy-modal',
    loadChildren: () => import('./privacy-modal/privacy-modal.module').then( m => m.PrivacyModalPageModule)
  },
  {
    path: 'contract-modal',
    loadChildren: () => import('./contract-modal/contract-modal.module').then( m => m.ContractModalPageModule)
  },
  {
    path: 'mesafeli-satis-sozlesmesi',
    loadChildren: () =>
    import('./mesafeli-satis-sozlesmesi/mesafeli-satis-sozlesmesi.module').then( m => m.MesafeliSatisSozlesmesiPageModule)
  },
  {
    path: 'iade-kosullari',
    loadChildren: () => import('./iade-kosullari/iade-kosullari.module').then( m => m.IadeKosullariPageModule)
  },
  {
    path: 'contact-modal',
    loadChildren: () => import('./contact-modal/contact-modal.module').then( m => m.ContactModalPageModule)
  },







];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubscriberRoutingModule {
}
